function generatorFunction(
    START_L_CODE, // 左開始字母
    START_S_CODE, // 右開始字母
    TYPE_A_AMT_PER_PERIOD, // 甲類個數
    TYPE_B_AMT_PER_PERIOD, // 乙類個數
    TYPE_C_AMT_PER_PERIOD, // 丙類個數
    TYPE_D_AMT_PER_PERIOD, // 丁類個數
    year, // 年度
) {
    //
    const PASS_CODE_LIST = [73, 79];
    const USABLE_CODE_LIST = [];
    const LOWER_BOUND = 65; // A
    const UPPER_BOUND = 90; // Z

    for (let i = LOWER_BOUND; i <= UPPER_BOUND; i += 1) {
        if (!PASS_CODE_LIST.includes(i)) USABLE_CODE_LIST.push(i);
    }

    //
    const TOTAL_AMT = (TYPE_A_AMT_PER_PERIOD + TYPE_B_AMT_PER_PERIOD + TYPE_C_AMT_PER_PERIOD + TYPE_D_AMT_PER_PERIOD) * 6;

    //
    const L_CURSOR = USABLE_CODE_LIST.indexOf(START_L_CODE.charCodeAt(0));
    let R_CURSOR = USABLE_CODE_LIST.indexOf(START_S_CODE.charCodeAt(0));

    const returnValue = [];

    let month = 1;
    let A = [];
    let B = [];
    let C = [];
    let D = [];

    for (let i = 0; i < TOTAL_AMT; i += 1) {
        const BOUNCED = Math.floor(R_CURSOR / USABLE_CODE_LIST.length);
        const L = USABLE_CODE_LIST[(L_CURSOR + BOUNCED) % USABLE_CODE_LIST.length];
        const R = USABLE_CODE_LIST[R_CURSOR % USABLE_CODE_LIST.length];

        const KEY = `${String.fromCodePoint(L)}${String.fromCodePoint(R)}`;

        const CYCLE = i % (TYPE_A_AMT_PER_PERIOD + TYPE_B_AMT_PER_PERIOD + TYPE_C_AMT_PER_PERIOD + TYPE_D_AMT_PER_PERIOD);
        const RANGE_A_UPPER = TYPE_A_AMT_PER_PERIOD;
        const RANGE_B_UPPER = TYPE_A_AMT_PER_PERIOD + TYPE_B_AMT_PER_PERIOD;
        const RANGE_C_UPPER = TYPE_A_AMT_PER_PERIOD + TYPE_B_AMT_PER_PERIOD + TYPE_C_AMT_PER_PERIOD;
        if (!CYCLE) {
            A = [];
            B = [];
            C = [];
            D = [];
        }

        if (CYCLE < RANGE_A_UPPER) A.push(KEY);
        else if (CYCLE >= RANGE_A_UPPER && CYCLE < RANGE_B_UPPER) B.push(KEY);
        else if (CYCLE >= RANGE_B_UPPER && CYCLE < RANGE_C_UPPER) C.push(KEY);
        else D.push(KEY);

        if (CYCLE === TYPE_A_AMT_PER_PERIOD + TYPE_B_AMT_PER_PERIOD + TYPE_C_AMT_PER_PERIOD + TYPE_D_AMT_PER_PERIOD - 1) {
            returnValue.push({
                year,
                month: [month, month + 1],
                datas: [
                    {
                        name: 'A',
                        serialNumbers: [...A],
                    },
                    {
                        name: 'B',
                        serialNumbers: [...B],
                    },
                    {
                        name: 'C',
                        serialNumbers: [...C],
                    },
                    {
                        name: 'D',
                        serialNumbers: [...D],
                    },
                ],
            });
            month += 2;
        }

        R_CURSOR += 1;

        // Check BB
        const AFTER_L = USABLE_CODE_LIST[(L_CURSOR + BOUNCED) % USABLE_CODE_LIST.length];
        const AFTER_R = USABLE_CODE_LIST[R_CURSOR % USABLE_CODE_LIST.length];
        if (AFTER_L === 66 && AFTER_R === 66) R_CURSOR += 1;
    }

    return returnValue;
}

const return2021 = generatorFunction('J', 'C', 2, 4, 2, 35, 2021);
const return2022 = generatorFunction('V', 'K', 2, 4, 2, 42, 2022);
const return2023 = generatorFunction('H', 'Y', 2, 3, 1, 42, 2023);
const return2024 = generatorFunction('V', 'Y', 2, 4, 0, 41, 2024);
const return2025 = generatorFunction('H', 'T', 2, 4, 0, 42, 2025);
const return2026 = generatorFunction('V', 'T', 2, 3, 1, 44, 2026);

export default [...return2021, ...return2022, ...return2023, ...return2024, ...return2025, ...return2026];
